<template>
    <div class="banner-abstract">
        <div class="inner">

            <!-- give it a person(al) touch -->
            <div v-if="hasPerson" class="person">
                <img :src="imageSrc" />
            </div>

            <!-- content of the banner -->
            <div class="content">

                <div class="title">
                    <slot name="title"></slot>
                </div>

                <div class="message">
                    <slot name="message"></slot>
                </div>

                <div class="actions">
                    <slot name="actions"></slot>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'BannerAbstract',
    props: {
        person: {
            type: String,
            default: null,
            validator(value) {
                return ['jonas'].includes(value);
            }
        }
    },
    computed: {
        hasPerson() {
            return this.person !== null && this.person !== undefined && this.person.length > 0;
        },
        imageSrc() {
            return this.hasPerson ? `/images/team/${this.person}.png` : null;
        }
    }
}
</script>

<style>
.banner-abstract .v-btn {
    background-color: rgb(var(--v-theme-darkbase));
}

.banner-abstract .v-btn:hover {
    background-color: rgba(var(--v-theme-color1), 0.5);
}
</style>

<style scoped>
.banner-abstract {
    width: 100%;
    /*background-color: rgba(var(--v-theme-color1), 0.2);*/
    background: linear-gradient(to bottom, rgb(var(--v-theme-darkerbase)), rgb(var(--v-theme-darkbase)));
}

.banner-abstract .inner {
    width: 100%;
    max-width: 1200px;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin: 0px auto;
}

.banner-abstract .person {
    flex-shrink: 1;
    height: 200px;
    max-height: 200px;
    display: flex;
    align-items: flex-end;
}

.banner-abstract .person img {
    height: 100%;
}

.banner-abstract .content {
    flex-grow: 1;
    padding-top: 25px;
    padding-bottom: 25px;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.banner-abstract .content .title {
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: left;
    color: rgb(var(--v-theme-invert));
}

.banner-abstract .content .message {
    width: 100%;
    font-size: 1.2rem;
    text-align: left;
    color: rgb(var(--v-theme-primary));
}

.banner-abstract .content .actions {
    width: 100%;
    text-align: right;
    margin-top: 10px;
}

@media (max-width: 800px) {
    .banner-abstract .person {
        height: 160px;
        max-height: 160px;
    }

    .banner-abstract .content .title {
        font-size: 1.2rem;
    }

    .banner-abstract .content .message {
        font-size: 1.0rem;
    }
}

@media (max-width: 600px) {
    .banner-abstract .inner {
        padding-left: 15px;
        padding-right: 15px;
    }

    .banner-abstract .person {
        height: 140px;
        max-height: 140px;
    }

    .banner-abstract .content .title {
        font-size: 1.1rem;
    }

    .banner-abstract .content .message {
        font-size: 1.0rem;
    }
}

@media (max-width: 400px) {
    .banner-abstract .inner {
        padding-left: 10px;
        padding-right: 10px;
    }

    .banner-abstract .person {
        height: 120px;
        max-height: 120px;
    }

    .banner-abstract .content .title {
        font-size: 1.0rem;
    }

    .banner-abstract .content .message {
        font-size: 0.9rem;
    }
}
</style>